import type { ExtractKeysWithDotNotation } from "@tellescope/ui";
import { useTypedSearchParams } from "../../../hooks/use-typed-search-params";

/**
 * The inbox's query-string state — just the transient search term.
 *
 * Filters live on the selected `table_views` record, and the view selection itself is a per-user
 * preference in the localStorage-backed inbox view store, so neither appears in the URL.
 */
export interface InboxQueryParams {
  search?: string;
}

const VALID_INBOX_QUERY_PARAM_KEYS = ["search"] as const satisfies ExtractKeysWithDotNotation<InboxQueryParams>[];

export const useInboxSearchParams = () => {
  return useTypedSearchParams<InboxQueryParams>(VALID_INBOX_QUERY_PARAM_KEYS);
};
